module.exports = __webpack_public_path__ + "static/img/toujiao5.56cfed1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toujiao5.jpg
// module id = nsu0
// module chunks = 1